import { Card as CardType, GambleTypes } from "../types";

interface GambleCard extends CardType {
  activity: GambleTypes | "other";
}

export const GAMBLE_CARDS: GambleCard[] = [
  {
    genre: "gamble",
    activity: "other",
    description:
      "Announce a number between 1-10. Roll and drink if it lands on it.",
    penaltyCost: 4,
    extras: ["randomNumber"],
    pub: true,
  },
  {
    genre: "gamble",
    activity: "other",
    description:
      "Flip a coin. Heads: Take off an article of clothing. Tails: Drink.",
    extras: ["coinFlip"],
    penaltyCost: 5,
  },
  {
    genre: "gamble",
    activity: "other",
    description:
      "Roll a die: Even = give a lap dance to the person 3 to the right, Odd = drink double the roll.",
    extras: ["randomNumber"],
    penaltyCost: 3,
    pub: true,
  },
  {
    genre: "gamble",
    activity: "other",
    description:
      "Roll a die: Even = Take a shot. Odd = Choose the person 4 to the right to take two shots.",
    extras: ["randomNumber"],
    penaltyCost: 3,
    pub: true,
  },
  {
    genre: "gamble",
    activity: "other",
    description:
      "Flip a coin: Heads = Remove a piece of clothing. Tails = Finish your drink.",
    penaltyCost: 5,
    extras: ["coinFlip"],
  },
  {
    genre: "gamble",
    activity: "danger",
    description:
      "Spin a bottle: The person it lands on gives you any dare. Refuse, and you drink.",
    penaltyCost: 4,
    pub: true,
  },
  {
    genre: "gamble",
    activity: "fates",
    description:
      "Bet on the next person's turn: If they complete their dare, you drink. If they fail, they drink.",
    penaltyCost: 3,
    pub: true,
  },
  {
    genre: "gamble",
    activity: "danger",
    description:
      "Choose the person 2 to the left to arm wrestle. Winner gives the loser a dare to complete.",
    penaltyCost: 4,
    pub: true,
  },
  {
    genre: "gamble",
    activity: "danger",
    description:
      "Bet: Guess the color of the person 3 to the left's underwear. If you're right, they drink. If wrong, you drink.",
    penaltyCost: 4,
    pub: true,
  },
  {
    genre: "gamble",
    activity: "other",
    description:
      "Dice roll: 1-3 = Kiss the person 5 to the right. 4-6 = Let the group choose who you kiss.",
    penaltyCost: 4,
    extras: ["randomNumber"],
    pub: true,
  },
  {
    genre: "gamble",
    activity: "other",
    description:
      "Flip a coin: Heads = Take a body shot off the person 2 to the left. Tails = They take one off you.",
    penaltyCost: 5,
    extras: ["coinFlip"],
  },
  {
    genre: "gamble",
    activity: "game",
    description:
      "Draw a random card: Red = Choose the person 6 to the right to swap clothes with. Black = Take a full drink.",
    penaltyCost: 4,
    extras: ["pickFromCardDeck"],
  },
  {
    genre: "gamble",
    activity: "fates",
    description:
      "Bet on whether the person 3 to the left can recite the alphabet backward perfectly. Loser drinks.",
    penaltyCost: 3,
    pub: true,
  },
  {
    genre: "gamble",
    activity: "danger",
    description:
      "Pick the person opposite, guess their type. If the group disagrees, you drink. If they agree, the chosen player drinks.",
    penaltyCost: 3,
    pub: true,
  },
  {
    genre: "gamble",
    activity: "other",
    description:
      "Roll a die: 1-3 = Post a flirty message on your story. 4-6 = Post something embarrassing.",
    penaltyCost: 5,
    extras: ["randomNumber"],
    pub: true,
  },

  {
    genre: "gamble",
    activity: "danger",
    description:
      "Spin a bottle: If it lands on you, remove a piece of clothing. If it lands on someone else, they drink.",
    penaltyCost: 5,
  },

  {
    description: "Do the same card as the next person.",
    penaltyCost: 0,
    genre: "gamble",
    activity: "fates",

    pub: true,
  },
  {
    description: "Do the same card as the previous person.",
    penaltyCost: 0,
    genre: "gamble",
    activity: "fates",
    pub: true,
  },

  {
    description: "Roll for cocktail !",
    penaltyCost: 4,
    genre: "gamble",
    activity: "danger",
    extras: ["rollForCocktail"],
  },
  {
    description:
      "Do the next person's card, you can't forfeit. Or take this card's penalty.",
    penaltyCost: 2,
    genre: "gamble",
    activity: "fates",

    pub: true,
  },
  {
    description:
      "Collect 3 items starting with a group chosen letter, and time limit. (Win removes penalty. Lose doubles penalty)",
    penaltyCost: 2,
    genre: "gamble",
    activity: "danger",
  },
  {
    description:
      "Group writes down a celeb and sticks it to your head. You have 20 yes/no questions to guess them. (Win removes penalty. Lose doubles penalty)",
    penaltyCost: 2,
    genre: "gamble",
    activity: "game",
  },
  {
    description:
      "Think fast! Name 5 breeds of cat in 30 seconds or loose an eyebrow (or do the shots)",
    penaltyCost: 2,
    genre: "gamble",
    activity: "game",
    pub: true,
  },
  {
    description: "Do the exactly the same as the next card drawn. ",
    penaltyCost: 2,
    genre: "gamble",
    activity: "fates",
    pub: true,
  },
  {
    description: "Do the exactly the same as the next 2 cards drawn. ",
    penaltyCost: 3,
    genre: "gamble",
    activity: "fates",
    pub: true,
  },
  {
    description: "Do the exactly the same as the next 3 cards drawn. ",
    penaltyCost: 4,
    genre: "gamble",
    activity: "fates",
    pub: true,
  },
  {
    description: "Do the exactly the same as the next 4 cards drawn. ",
    penaltyCost: 5,
    genre: "gamble",
    activity: "fates",
    pub: true,
  },
  {
    description: "Do the exactly the same as the next 5 cards drawn. ",
    penaltyCost: 5,
    genre: "gamble",
    activity: "fates",
    pub: true,
  },
  {
    description: "Flip a coin. (Head removes penalty. Tails doubles penalty)",
    penaltyCost: 2,
    genre: "gamble",
    activity: "game",
    pub: true,
  },
  {
    description:
      "Do 10 push ups without stopping (Win removes penalty. Lose doubles penalty)",
    penaltyCost: 1,
    genre: "gamble",
    activity: "danger",
    pub: true,
  },

  {
    description:
      "Roll for sandwich! Group makes you some combination of the snacks left avaliable. ",
    penaltyCost: 3,
    genre: "gamble",
    activity: "danger",
  },

  {
    description:
      "Dont read out this card and show card to the right. Person opposite calls heads or tails. (Heads removes penalty. Tails doubles penalty)",
    penaltyCost: 2,
    genre: "gamble",
    activity: "game",

    pub: true,
    extras: ["coinFlip"],
  },
  {
    description:
      "Dont read out this card and show card to the right. Person opposite calls heads or tails. (Tails removes penalty. Heads doubles penalty)",
    penaltyCost: 2,
    genre: "gamble",
    activity: "game",
    pub: true,
    extras: ["coinFlip"],
  },
  {
    description:
      "Dont read out this card and show card to the right. Person opposite calls out a number between 1 and 5. Then, remove that many clothes.",
    penaltyCost: 4,
    genre: "gamble",
    activity: "game",
    pub: true,
  },
  {
    description:
      "Dont read out this card and show card to the right. Person opposite calls out a number between 1 and 5. Then, put on that many clothes.",
    penaltyCost: 1,
    genre: "gamble",
    activity: "game",
    pub: true,
  },
  {
    description:
      "Dont read out this card and show card to the right. Person opposite calls out a number between 1 and 3. Then, remove that many clothes.",
    penaltyCost: 2,
    genre: "gamble",
    activity: "game",
    pub: true,
  },
  {
    description:
      "Dont read out this card and show card to the right. Person opposite calls out a number between 1 and 3. Then, put on that many clothes.",
    penaltyCost: 1,
    genre: "gamble",
    activity: "game",
    pub: true,
  },
  {
    description:
      "Annouce you are looking for dares. The next dare card that is played by anyone, you do it first with a penalty cost of 5.",
    penaltyCost: 3,
    genre: "gamble",
    activity: "game",
    pub: true,
  },
  {
    description:
      "Annouce you are looking for truths. The next truth card that is played by anyone, you do it first with a penalty cost of 5.",
    penaltyCost: 3,
    genre: "gamble",
    activity: "game",
    pub: true,
  },
  {
    description:
      "Annouce you are looking for curses. The next curse card that is played by anyone, you do it first with a penalty cost of 5.",
    penaltyCost: 3,
    genre: "gamble",
    activity: "game",
    pub: true,
  },

  {
    genre: "gamble",
    activity: "danger",
    description:
      "You must keep a straight face for the next 30 seconds while the group tries to make you laugh. If you fail, drink.",
    penaltyCost: 2,
    pub: true,
  },
  {
    genre: "gamble",
    activity: "game",
    description:
      "Call heads or tails. If you lose, you take off 2 items of clothing.",
    penaltyCost: 5,
    extras: ["coinFlip"],
  },

  {
    genre: "gamble",
    activity: "game",
    description:
      "Call heads or tails. If you lose, you take off 8 items of clothing.",
    penaltyCost: 5,
    extras: ["coinFlip"],
  },
  {
    genre: "gamble",
    activity: "game",
    description:
      "Call heads or tails. If you lose, you take off 1 item of clothing.",
    penaltyCost: 3,
    extras: ["coinFlip"],
  },
  {
    genre: "gamble",
    activity: "other",
    description:
      "Announce a number between 1-10. Roll and drink if it's lands on it.",
    penaltyCost: 4,
    pub: true,
    extras: ["randomNumber"],
  },

  {
    description: "Roll a D6. Take that many drinks.",
    penaltyCost: 4,
    genre: "gamble",
    activity: "other",
    extras: ["randomNumber"],
    pub: true,
  },
  {
    description: "Flip a coin: Heads = Give 2 drinks, Tails = Take 2 drinks.",
    penaltyCost: 4,
    genre: "gamble",
    activity: "other",
    extras: ["coinFlip"],
    pub: true,
  },

  {
    genre: "gamble",
    activity: "game",
    description:
      "Call the next card type. If wrong, you take off 1 item of clothing.",
    penaltyCost: 3,
    extras: ["coinFlip"],
  },

  {
    genre: "gamble",
    activity: "game",
    description:
      "Call the next card type. If wrong, you take off 3 items of clothing.",
    penaltyCost: 5,
    extras: ["coinFlip"],
  },

  {
    genre: "gamble",
    activity: "game",
    description:
      "Take off the same number of clothes as the next card drawn's cost.",
    penaltyCost: 4,
  },

  {
    genre: "gamble",
    activity: "game",
    description:
      "Guess this number (1-5). Wrong, you take off 1 item of clothing. Right, you nomimate someone to do it. (Answer: 1)",
    penaltyCost: 2,
  },

  {
    genre: "gamble",
    activity: "game",
    description:
      "Guess this number (1-5). Wrong, you take off 1 item of clothing. Right, you nomimate someone to do it. (Answer: 2)",
    penaltyCost: 2,
  },

  {
    genre: "gamble",
    activity: "game",
    description:
      "Guess this number (1-5). Wrong, you take off 1 item of clothing. Right, you nomimate someone to do it. (Answer: 3)",
    penaltyCost: 2,
  },
  {
    genre: "gamble",
    activity: "game",
    description:
      "Guess this number (1-5). Wrong, you take off 1 item of clothing. Right, you nomimate someone to do it. (Answer: 4)",
    penaltyCost: 2,
  },
  {
    genre: "gamble",
    activity: "game",
    description:
      "Guess this number (1-5). Wrong, you take off 1 item of clothing. Right, you nomimate someone to do it. (Answer: 5)",
    penaltyCost: 2,
  },

  {
    genre: "gamble",
    activity: "game",
    description:
      "Guess this number (1-3). Wrong, you take off 2 items of clothing. Right, you nomimate someone to do it. (Answer: 1)",
    penaltyCost: 4,
  },

  {
    genre: "gamble",
    activity: "game",
    description:
      "Guess this number (1-3). Wrong, you take off 2 items of clothing. Right, you nomimate someone to do it. (Answer: 2)",
    penaltyCost: 4,
  },
  {
    genre: "gamble",
    activity: "game",
    description:
      "Guess this number (1-3). Wrong, you take off 2 items of clothing. Right, you nomimate someone to do it. (Answer: 3)",
    penaltyCost: 4,
  },
];
